'use client'
import React, { ReactElement } from 'react'

export interface GridRowProps extends React.HTMLAttributes<HTMLDivElement> {
    columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    gap?: 2 | 4 | 6
    children: ReactElement | ReactElement[]
}

// Complete class names must stay as literals so Tailwind's scanner keeps them.
// `gap-${gap}` / `grid-cols-${columns}` would be tree-shaken because the built class is not statically visible.
const gapClasses = {
    2: 'gap-2',
    4: 'gap-4',
    6: 'gap-6',
}

const columnClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
    7: 'grid-cols-7',
    8: 'grid-cols-8',
    9: 'grid-cols-9',
    10: 'grid-cols-10',
    11: 'grid-cols-11',
    12: 'grid-cols-12',
}

export const GridRow = ({ columns, gap = 6, children, className, ...props }: GridRowProps): ReactElement => {
    return (
        <div
            {...props}
            className={`grid ${gapClasses[gap]} ${columns ? columnClasses[columns] : ''} ${className ?? ''}`}
        >
            {children}
        </div>
    )
}
